module.exports = __webpack_public_path__ + "static/media/pepper.ee62ac0b.svg";